import app from 'flarum/forum/app';
import Page from 'flarum/common/components/Page';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import { data, ROUTE } from '../../common/community';
import { rememberInvite } from '../../common/invite';

/** /join/{code}: the welcome page an invite link opens. */
export default class JoinPage extends Page {
  oninit(vnode) {
    super.oninit(vnode);
    this.code = m.route.param('code');
    this.invite = null;
    this.error = null;
    app.setTitle('Join your community');
    app.request({
      method: 'GET',
      url: app.forum.attribute('apiUrl') + '/voucha-community/invites/' + encodeURIComponent(this.code),
      errorHandler: () => {}
    }).then(r => {
      this.invite = r;
      rememberInvite(r); // so setup can use it after they sign up
    }).catch(e => this.error = e?.response?.message || 'This invite link is no longer valid.').finally(() => m.redraw());
  }
  view() {
    if (this.error) {
      return m("div", {
        className: "JoinPage container"
      }, m("div", {
        className: "VouchaJoin"
      }, m("h2", null, "Invite not found"), m("p", null, this.error), m("a", {
        className: "Button Button--primary",
        href: app.route(ROUTE)
      }, "See My Community")));
    }
    if (!this.invite) return m("div", {
      className: "JoinPage container"
    }, m(LoadingIndicator, null));
    const p = this.invite.place;
    const user = app.session.user;
    const state = data().state;
    return m("div", {
      className: "JoinPage container"
    }, m("div", {
      className: "VouchaJoin"
    }, m("i", {
      className: "fas fa-users JoinPage-icon",
      "aria-hidden": "true"
    }), m("h2", null, "Join Nigerians from ", p.name, " on Voucha"), m("p", null, this.invite.inviter ? m("strong", null, this.invite.inviter) : 'A member', " invited you to the ", p.name, " community: local news, questions, and people who know home."), !user ? [m("button", {
      className: "Button Button--primary VouchaJoin-cta",
      onclick: () => this.click('.item-signUp .Button, .item-signUp button')
    }, "Join now"), m("p", {
      className: "VouchaJoin-small"
    }, "Already a member?", ' ', m("a", {
      href: "#",
      onclick: e => {
        e.preventDefault();
        this.click('.item-logIn .Button, .item-logIn button');
      }
    }, "Log in"))] : state === 'ok' ? [m("p", {
      className: "VouchaJoin-small"
    }, "You've already set up My Community."), m("a", {
      className: "Button Button--primary",
      href: app.route(ROUTE)
    }, "Go to My Community")] : m("a", {
      className: "Button Button--primary VouchaJoin-cta",
      href: app.route(ROUTE)
    }, "Set up my community")));
  }
  click(selector) {
    const b = document.querySelector(selector);
    if (b) b.click();
  }
}
flarum.reg.add('voucha-community', 'forum/components/JoinPage', JoinPage);